import ReactSVG from "react-svg"
import ArrowLeft from "../../../../images/go_back_icon_white.svg"
import { isDesktop } from "react-device-detect"
import React from "react"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"

const RewardsProgramRules = ({ history }) => {
  const hash = window.location.hash
  const queryString = hash.includes("?") ? hash.split("?")[1] : ""
  const isMobile = new URLSearchParams(queryString).get("isMobile") === "true"

  return (
    <div className="rewards-program-rules">
      <div className="service-request-header">
        <div className="header-content">
          {!isMobile && (
            <div className="back-button" onClick={() => history.goBack()}>
              <ReactSVG src={ArrowLeft} />
              {isDesktop && <p>Go back</p>}
            </div>
          )}

          <div className="service-request-stepper">
            <p className="bold">Program Rules</p>
          </div>

          {!isMobile && (
            <p className="cancel-text" onClick={() => history.goBack()}>
              Cancel
            </p>
          )}
        </div>
      </div>

      <div className="service-request-content rules-content">
        <ul className="rules-list">
          <li>
            Earn 1 Point for every $1 spent on eligible maintenance services booked and paid through
            CarAdvise.
          </li>
          <li>
            Points are earned on tire purchases made through CA360 when those tires are booked and
            installed with CarAdvise.
          </li>
          <li>
            Points are not earned on tires purchased through third-party marketplaces like eBay, or
            when CarAdvise is not used to book and complete the install.
          </li>
          <li>
            Points are not earned on fuel, taxes, shop fees, or other excluded items listed in the
            Rewards Terms.
          </li>
          <li>
            Points have no cash value and are not refundable, transferable, or redeemable for cash.
          </li>
          <li>
            Points can only be redeemed as Service Credit on eligible services at participating
            shops.
          </li>
          <li>
            Points are earned only on eligible service spend after discounts; taxes, fees, and
            certain items may not earn Points.
          </li>
          <li>
            For services financed through partners like Affirm, Points are earned when the service
            is completed and the transaction is approved and not later canceled or refunded.
          </li>
          <li>
            Points are not awarded for services that are only logged manually or uploaded to your
            maintenance history without being booked and paid through CarAdvise.
          </li>
          <li>Points, bonuses, and earn and redemption rates may change at any time.</li>
          <li>Rewards and promo offers may be combinable; additional exclusions may apply.</li>
          <li>
            CarAdvise may adjust your Points balance for returns, cancellations, errors, or
            suspected fraud.
          </li>
          <li>
            CarAdvise may suspend or end the Rewards Program at any time, subject to applicable law.
          </li>
        </ul>
      </div>
    </div>
  )
}

export default withRouter(connect()(RewardsProgramRules))
